export default function Footer() {
    return (
        <section className=" w-full bg-gray-700 mt-[20px] max-[526px]:">
            <h1 className=" text-center pt-[20px] pb-[20px] max-[526px]:text-[11px] max-[362px]:text-[8px]">@2018-2019 NETFLIX Watch all movies | All Rights Reserved</h1>
        </section>
    )
}